import axios from 'axios';

export default (id) => axios.get(`${process.env.VUE_APP_API_ENDPOINT}/firms/${id}`);
